import {gql} from '@apollo/client'

export const SING_IN = gql`
  mutation loginProvider($username: String!, $password: String!) {
      loginProvider(email: $username, password: $password) {
        token
        typeUser
      }
  }
`;

export const USER_INFO = gql`
    query {
        user {
            id
            names
            profile_pic
            roles            
            typeUser
            manager {
              studio_id
              branch_id
            }
        }
    }
`;
